import { h, provide, createApp } from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import axios from 'axios';
import { Storage } from '../Consts/Storage';
import Alert from '@util/BrowserAlert';
// Axiosの設定
// baseURLを設定しないことで、同一オリジンリクエストとなりCORS不要
// axios.defaults.baseURL = Storage.REMOTE_BASE_URL;
axios.defaults.timeout = 30 * 1000;
axios.defaults.responseType = 'json';
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest';
axios.interceptors.response.use(response => {
    return response;
}, error => {
    var _a;
    Alert.RequestError((_a = error.response) === null || _a === void 0 ? void 0 : _a.status);
    return error;
});
window.axios = axios;
// Stripe公開鍵をグローバルに設定
window.stripePublicKey = Storage.STRIPE_PUBLIC_KEY;
createInertiaApp({
    resolve: name => require(`./Pages/${name}`),
    setup({ el, app, props, plugin }) {
        createApp({
            render: () => h(app, props),
            mounted: () => {
                // console.log('CreateApp mounted');
            },
            updated: () => {
                // console.log('CreateApp updated');
            },
            setup() {
                console.log('App setup - Storage.STRIPE_PUBLIC_KEY:', Storage.STRIPE_PUBLIC_KEY);
                console.log('App setup - type:', typeof Storage.STRIPE_PUBLIC_KEY);
                provide('remoteBaseUrl', Storage.REMOTE_BASE_URL);
                provide('recaptchaSiteKey', Storage.RECAPTCHA_SITE_KEY);
                provide('stripePublicKey', Storage.STRIPE_PUBLIC_KEY);
            },
        })
            .use(plugin)
            .mixin({
            methods: {
                route: (name, params, absolute, Ziggy) => route(name, params, absolute, Ziggy),
            },
        })
            .mount(el);
    },
});
